import Box from '@mui/material/Box'

import { useOnMount } from 'hooks'

import { adStyle } from './CarbonAds.styles'

function CarbonAds() {
  useOnMount(() => {
    if (process.env.NODE_ENV !== 'development') {
      const ads = document.getElementsByClassName('ads')[0]
      const script = document.createElement('script')
      script.src = '//cdn.carbonads.com/carbon.js?serve=CK7I62QW&placement=wwwzuyetawarmatripcom'
      script.id = '_carbonads_js'
      script.async = true
      ads.appendChild(script)
    }
  })

  return (
    <Box sx={adStyle}>
      <div className="ads" />
    </Box>
  )
}

export default CarbonAds
